import { useTransaction } from "hooks/useTransactions";
import * as i18n from "util/i18n";
import Button from "pages/_components/Button";
import { ResponsiveHeader } from "pages/_components/header";
import MainContainer from "pages/_components/MainContainer";
import Notification from "pages/_components/Notification";
import useReactPrint from "pages/_components/Print/useReactToPrint";
import { TransactionCard, TransactionHeader } from "pages/_components/TransactionCard";
import { bool } from "prop-types";
import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { actions as servicePaymentsActions } from "reducers/servicePayments";
import gaEventTracker, { events } from "util/gaEventTracker";
import { ServicePaymentSummaryBody } from "./components/SummaryBody";

const ServicePaymentTransactionPage = ({ isDesktop }) => {
    const formatTransactionTransfer = (data, idTransaction) => ({ ...data, idTransaction });

    const {
        isLoading,
        transaction,
        dispatch,
        handleSignTransaction,
        showSignButton,
        push,
        id,
        status,
    } = useTransaction(
        `/servicePayments/summary`,
        servicePaymentsActions.setPrepareData,
        servicePaymentsActions.cleanServiceTicket,
        formatTransactionTransfer,
    );
    const [showMoreData, setShowMoreData] = useState(!isDesktop);
    const [vaucherLoading, setVaucherLoading] = useState(false);

    const { isFlowComplete, isFinished, isBackoffice } = status;
    const { componentRef, handlePrint, mobileRef, handleShareMobile } = useReactPrint(
        "payments.service.new",
        id,
        "servicePaymentTransactionPage",
    );

    const backLinkTo = isFlowComplete ? "/servicePayments" : "";

    const handleDownload = async () => {
        await setShowMoreData(true);
        gaEventTracker.triggerEvent(events.pagoServicio_descargar());
        gaEventTracker.triggerEvent(events.pagos_pagar_descargar());
        return handlePrint();
    };

    return (
        <>
            {isFinished && <Notification scopeToShow="servicePaymentTransactionPage" />}
            {!isBackoffice && <ResponsiveHeader ticket metaTitle="payments.service.new" backLinkTo={backLinkTo} />}
            <MainContainer showLoader={isLoading || vaucherLoading}>
                <div className="container" ref={componentRef} style={{ paddingBottom: "48px" }}>
                    <div ref={mobileRef}>
                        <TransactionCard transaction={transaction}>
                            <TransactionHeader title="payments.service.new" isDesktop={isDesktop} />
                            <div className="ticket">
                                <div className="ticket__wrapper">
                                    <div className="ticket__header" />
                                    <ServicePaymentSummaryBody
                                        isTicket
                                        isDesktop={isDesktop}
                                        showMoreData={showMoreData}
                                        setShowMoreData={setShowMoreData}
                                        setVaucherLoading={setVaucherLoading}
                                    />
                                    <div className="ticket__footer" data-copytext={i18n.get("global.ticketCopyText")} />
                                </div>
                            </div>
                        </TransactionCard>
                    </div>
                    {!isBackoffice && (
                        <Row className="form-actions no-print">
                            <Col xs={0} md={1} />
                            <Col xs={12} md={5}>
                                {isFinished ? (
                                    <Button
                                        className="btn btn-outline"
                                        image="images/figma/icon/download.svg"
                                        label="global.download"
                                        onClick={handleDownload}
                                    />
                                ) : (
                                    <Button
                                        onClick={() => dispatch(push("/desktop"))}
                                        label="forms.transaction.ticket.actions.backToHome"
                                        className="btn btn-outline"
                                    />
                                )}
                            </Col>
                            {isFinished && !isDesktop && (
                                <Col xs={12} md={5}>
                                    <Button
                                        className="btn btn-outline"
                                        image="images/figma/icon/share.svg"
                                        label="global.share"
                                        onClick={() => {
                                            handleShareMobile();
                                        }}
                                    />
                                </Col>
                            )}
                            <Col xs={12} md={5}>
                                {showSignButton ? (
                                    <Button
                                        onClick={handleSignTransaction}
                                        label="forms.signTransaction.link"
                                        className="btn btn-primary"
                                    />
                                ) : (
                                    <Button
                                        onClick={() => dispatch(push("/servicePayments/new"))}
                                        label="payments.service.otherPayment"
                                        className={`btn${showSignButton ? " btn-outline" : " btn-primary"}`}
                                    />
                                )}
                            </Col>
                        </Row>
                    )}
                </div>
            </MainContainer>
        </>
    );
};

ServicePaymentTransactionPage.propTypes = {
    isDesktop: bool.isRequired,
};

export default ServicePaymentTransactionPage;
